import React from "react";
import Container from "./styled";

var number = 1;

export default class ChangeCanales extends React.Component {
  constructor(props) {
    super(props);
    this.state = { key: 1 };
  }

  handleSelect(key, canalesCategory) {
    this.props.toggleCanales(canalesCategory);
    this.setState({ key });
    number = key;
  }

  render() {
    return (
      <Container activeKey={this.state.key}>
        <button
          eventKey={1}
          onClick={() => this.handleSelect(1, "Atención")}
          className={number == "1" && "active"}
        >
          Atención al cliente
          <i></i>
        </button>
        <button
          eventKey={2}
          onClick={() => this.handleSelect(2, "Siniestros")}
          className={number == "2" && "active"}
        >
          Siniestros
          <i></i>
        </button>
        <button
          eventKey={3}
          onClick={() => this.handleSelect(3, "Cobranzas")}
          className={number == "3" && "active"}
        >
          Cobranzas
          <i></i>
        </button>
      </Container>
    );
  }
}
